import React from 'react';
import { TextBlock } from '../../ast/document.types';

interface TextBlockRendererProps {
  block: TextBlock;
}

export const TextBlockRenderer: React.FC<TextBlockRendererProps> = ({ block }) => {
  const { text, formatting } = block.data;

  const textDecorations: string[] = [];
  if (formatting?.underline) textDecorations.push('underline');
  if (formatting?.strikethrough) textDecorations.push('line-through');

  const style: React.CSSProperties = {
    fontFamily: formatting?.fontFamily || 'inherit',
    fontWeight: formatting?.bold ? 'bold' : 'normal',
    fontStyle: formatting?.italic ? 'italic' : 'normal',
    textDecoration: textDecorations.length > 0 ? textDecorations.join(' ') : 'none',
    textAlign: formatting?.alignment || 'left',
    color: formatting?.color || 'inherit',
    backgroundColor: formatting?.backgroundColor || 'transparent',
    fontSize: formatting?.fontSizePt ? `${formatting.fontSizePt}pt` : 'inherit',
    lineHeight: formatting?.lineHeightMultiplier ? formatting.lineHeightMultiplier : 1.6,
    letterSpacing: formatting?.letterSpacingPx ? `${formatting.letterSpacingPx}px` : undefined,
    whiteSpace: 'pre-wrap',
    margin: '6px 0',
    opacity: typeof formatting?.opacity === 'number' ? formatting.opacity : 1,
    transform: `translate(${formatting?.offsetX || 0}px, ${formatting?.offsetY || 0}px)${formatting?.rotation ? ` rotate(${formatting.rotation}deg)` : ''}`,
    transition: 'transform 0.05s ease-out',
  };

  if (!text || text.trim() === '') {
    return (
      <div style={{ ...style, color: '#9ca3af', fontStyle: 'italic', fontSize: '12px' }}>
        [Empty text block]
      </div>
    );
  }

  if (formatting?.subscript) {
    return <p style={style}><sub>{text}</sub></p>;
  }
  if (formatting?.superscript) {
    return <p style={style}><sup>{text}</sup></p>;
  }

  return <p style={style}>{text}</p>;
};
